import { useContext } from 'react';
import { CompanyContext } from '../providers/CompanyProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(CompanyContext);
